import { useEffect, useState, useCallback } from "react";
import { statusRequestBatcher } from "@/utils/status-request-batcher";
import { UserStatus } from "@/components/user-avatar/types";

const REFRESH_STATUS_PERIOD = 180000; // 3 minutes

export const useStatus = (
  statusUrl: string | undefined,
  userId: string | undefined,
): { status: UserStatus } => {
  const [status, setStatus] = useState<UserStatus>(UserStatus.PresenceUnknown);

  const fetchStatus = useCallback(
    (api: string | undefined) => {
      if (!api || !userId) {
        return;
      }

      return statusRequestBatcher
        .getStatus(api, userId)
        .then(status => {
          setStatus(status?.availability || UserStatus.PresenceUnknown);
        })
        .catch(() => setStatus(UserStatus.PresenceUnknown));
    },
    [userId],
  );

  useEffect(() => {
    setStatus(UserStatus.PresenceUnknown);
    fetchStatus(statusUrl);

    const interval = setInterval(async () => {
      await fetchStatus(statusUrl);
    }, REFRESH_STATUS_PERIOD);

    return () => {
      clearInterval(interval);
    };
  }, [fetchStatus, statusUrl]);

  return { status };
};
